import { MdOutlineEventAvailable, MdBuild, MdLogout } from "react-icons/md";
import { FaRegAddressCard, FaHome, FaUserPlus, FaUsers, FaChartBar, FaTicketAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import UserAvatar from './UI/UserAvatar'

const SideBar = ({ onLogout, onClose }) => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                         window.innerWidth < 768
            setIsMobile(mobile)
        }
        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    const handleLinkClick = () => {
        if (onClose) onClose();
    };

    return (
        <div className={`h-screen w-64 m-0 flex flex-col ${isMobile ? 'bg-slate-900/98' : 'bg-black/20 backdrop-blur-xl'} border-r border-white/10 text-white shadow-2xl`}>
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-white/10">
                <div className="flex items-center gap-3">
                    <UserAvatar size="md" className="rounded-xl" />
                    <span className="font-semibold text-lg text-white">MainStage</span>
                </div>
                <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            {/* Navigation Items */}
            <div className="flex-1 flex flex-col gap-2 p-4">
                <Link to="/home" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaHome size="20" />} text="Home" />
                </Link>
                <Link to="/passport" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaRegAddressCard size="20" />} text="Event Passport" />
                </Link>
                <Link to="/discover" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaTicketAlt size="20" />} text="Discover" />
                </Link>
                <Link to="/newEvent" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<MdOutlineEventAvailable size="22" />} text="Add Event" />
                </Link>
                <Link to="/add-friend" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaUserPlus size="20" />} text="Friends" />
                </Link>
                <Link to="/friends-feed" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaUsers size="20" />} text="Friends Feed" />
                </Link>
                <Link to="/stats" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<FaChartBar size="20" />} text="Stats" />
                </Link>
                <Link to="/settings" onClick={handleLinkClick}>
                    <SideBarMenuItem icon={<MdBuild size="20" />} text="Settings" />
                </Link>
            </div>

            {/* Logout */}
            <div className="p-4 border-t border-white/10">
                <SideBarMenuItem 
                    icon={<MdLogout size="20" />} 
                    text="Logout" 
                    onClick={onLogout}
                />
            </div>
        </div>
    );
};

const SideBarMenuItem = ({ icon, text, onClick }) => (
    <div
        className='flex items-center gap-3 p-3 rounded-lg hover:bg-white/10 transition-all duration-300 cursor-pointer group border border-transparent hover:border-white/20 text-gray-300 hover:text-white'
        onClick={onClick}
    >
        <div className="flex items-center justify-center w-8 h-8">
            {icon}
        </div>
        <span className='text-sm font-medium'>
            {text}
        </span>
    </div>
);

export default SideBar